import React from "react";
import { useRecoilValue } from "recoil";
import { Box } from "@mui/material";
import { Root } from "./oc-public-layout.style";
import { useOcIsMobile } from "oc/hooks/use-is-mobile";
import { darkBackgroundState } from "./oc-public-layout-states";

export const OcPublicLayout: React.FC<React.PropsWithChildren<{}>> = ({
  children,
}) => {
  const isMobile = useOcIsMobile();
  const darkBackground = useRecoilValue(darkBackgroundState);
  let transparency = darkBackground ? "rgba(0,0,0,0.7)" : "transparent";

  return (
    <Root
      isMobile={isMobile}
      id="common-picture-background"
      style={{
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        position: "absolute",
        zIndex: 10000,
      }}
    >
      <Box width="100%" height="100%" sx={{ backgroundColor: transparency }}>
        {children}
      </Box>
    </Root>
  );
};

export default OcPublicLayout;
